// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__1o-3_","messages":"Chat_messages__3rk1-","dateDivider":"Chat_dateDivider__1zYfy"};